import {IStore} from "modules/types/store";
import {createSelector} from "reselect";

export const getModalState = (store: IStore) => store.modals;
export const getErrorModalMessage = createSelector(getModalState, ({error}) => error);
export const getSuccessModalMessage = createSelector(getModalState, ({message}) => message);

export const getIsOpenModals = createSelector(getModalState, ({isOpenModals}) => isOpenModals);

export const getIsOpenSuccessChangePasswordModal = createSelector(
	getIsOpenModals,
	({successChangePassword}) => successChangePassword
);

export const getIsOpenSuccessRecoveryPasswordModal = createSelector(
	getIsOpenModals,
	({successRecoveryPassword}) => successRecoveryPassword
);

export const getIsOpenChangeAvatarModal = createSelector(
	getIsOpenModals,
	({changeAvatar}) => changeAvatar
);

export const getBadgeModalName = createSelector(
	getModalState,
	({badgeModalName}) => badgeModalName
);

export const getIsOpenSuccessUpdateProfileModal = createSelector(
	getIsOpenModals,
	({successUpdateProfile}) => successUpdateProfile
);
